'use client';

import { forwardRef, type ComponentPropsWithoutRef, type ElementRef, type ReactNode } from 'react';

import { Separator } from '../../primitives/separator';
import { cn } from '../../utils/cn';

export interface UzSeparatorProps extends ComponentPropsWithoutRef<typeof Separator> {
  /** Inline label centred on the rule (horizontal orientation only). */
  label?: ReactNode;
}

/**
 * Horizontal/vertical divider. With `label`, renders a centred caption with
 * lines on either side (e.g. "OR" between alternative actions).
 */
export const UzSeparator = forwardRef<ElementRef<typeof Separator>, UzSeparatorProps>(
  ({ label, orientation = 'horizontal', className, ...rest }, ref) => {
    if (!label || orientation === 'vertical') {
      return <Separator ref={ref} orientation={orientation} className={className} {...rest} />;
    }
    return (
      <div
        className={cn(
          'text-muted-foreground flex items-center gap-3 text-xs tracking-wider uppercase',
          className,
        )}
      >
        <Separator className="flex-1" />
        <span>{label}</span>
        <Separator className="flex-1" />
      </div>
    );
  },
);
UzSeparator.displayName = 'UzSeparator';
